<template>
  <ConfirmationPopup
    ref="confirmationPopup"
    type="warning"
    :closeable="false"
    title="Увага! Санкції"
    message=""
    :max-width="500"
    :controls="[
      { type: 'default', label: 'Закрити', event: 'close' },
    ]"
    @close="onClose"
  >
    <p class="sanctions-alert__status-message">{{ statusMessage }}</p>
    <div class="sanctions-alert__fields" v-if="sanctionFields.length">
      <SanctionField
        v-for="field in sanctionFields"
        :key="field.key"
        :label="field.label"
        :value="field.value"
      />
    </div>
  </ConfirmationPopup>
</template>

<script>
import { default as SanctionField } from './sanctions-field';
import { sanctionsFallbackMessage, sanctionsStatusMessage } from '@/entities/insurance';
import { ConfirmationPopup } from '@/shared/ui/popup';

export default {
  props: {
    sanctionsData: { type: Object, default: null },
    isSanctioned: { type: Boolean, default: false },
  },
  mounted() {
    if (this.isSanctioned) {
      this.$nextTick(() => this.open());
    }
  },
  components: { ConfirmationPopup, SanctionField },
  computed: {
    statusMessage() {
      const status = this.sanctionsData?.status;
      if (status && sanctionsStatusMessage[status]) {
        return sanctionsStatusMessage[status];
      }

      if (status === 'sanctioned' || status === 'possible_match') {
        return sanctionsStatusMessage.possible_match;
      }

      return sanctionsFallbackMessage;
    },
    sanctionData() {
      const raw = this.sanctionsData?.sanctionMessage;
      return this.extractMessageData(raw);
    },
    birthdateLabel() {
      return this.sanctionData?.customerType === 2 ? 'Дата створення' : 'Дата народження';
    },
    sanctionFields() {
      if (!this.sanctionData) return [];

      return [
        { key: 'name', label: 'Ім\'я', value: this.coerceToString(this.sanctionData.name) },
        { key: 'birthdate', label: this.birthdateLabel, value: this.coerceToString(this.sanctionData.birthdate) },
        { key: 'identity_docs', label: 'Документи', value: this.coerceToString(this.sanctionData.identity_docs) },
        { key: 'sanctions', label: 'Санкції', value: this.coerceToString(this.sanctionData.sanctions) },
      ];
    },
  },
  methods: {
    extractMessageData(messageObj) {
      if (Array.isArray(messageObj) && messageObj.length > 0) {
        return messageObj[0];
      }
      if (messageObj && typeof messageObj === 'object') {
        return messageObj;
      }
      return null;
    },
    coerceToString(value) {
      if (value == null) return null;
      if (typeof value === 'string') return value;
      if (typeof value === 'number') return String(value);
      if (Array.isArray(value)) return value.join(', ');
      if (typeof value === 'object') {
        try {
          return Object.values(value).filter(Boolean).join(', ');
        } catch {
          return null;
        }
      }
      return null;
    },
    open() {
      this.$refs.confirmationPopup.open();
    },
    close() {
      this.$refs.confirmationPopup.close();
    },
    onClose() {
      this.$emit('set-sanctions', {
        isSanctioned: false,
        sanctionMessage: null,
        status: null,
      });
    },
  },
  watch: {
    isSanctioned(value) {
      if (value) {
        this.$nextTick(() => this.open());
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sanctions-alert {
  &__status-message {
    font-size: 14px;
    font-weight: 400;
    color: #FF3B30;
    margin-bottom: 16px;
  }

  &__fields {
    margin-top: 12px;
  }
}
</style>
